import React from 'react';
import { Loader } from '@domain-group/fe-blueprint-ui/loader';
import * as styles from './loading.style';

const Loading = (): JSX.Element => (
  <div css={styles.loadingWrapper}>
    <div css={styles.loadingElement}>
      <Loader />
    </div>
  </div>
);

export default Loading;
